import React, { useState } from "react";
import { Form } from "react-bootstrap";
import "./textInput.css";

const TextInputField = ({
    label,
    name,
    required,
    value = "",
    type = "text",
    onChange = () => { }, // Default no-op function
    placeholder,
    feedbackMessage,
    validationRegex,
    validationErrorMessage = "Invalid input",
    maxLength,
    disabled,
    onClick,
    onKeyDown
}) => {
    const [error, setError] = useState(null);

    const isPassword = type === "password";

    const handleInputChange = (event) => {
        let inputValue = event.target.value;

        // Limit input length if maxLength is provided
        if (maxLength && inputValue.length > maxLength) {
            inputValue = inputValue.substring(0, maxLength);
        }

        // Validate input
        const isValidInput = validationRegex ? validationRegex.test(inputValue) : true;

        // Update error state and call onChange prop
        if (isValidInput || !inputValue) { // Allow empty input to clear error
            setError(null);
            onChange({ target: { name, value: inputValue } });
        } else {
            setError(validationErrorMessage);
        }
    };

    const handleKeyDown = (event) => {
        if (onKeyDown) {
            onKeyDown(event); // Ensure onKeyDown is called
        }
    };

    if (isPassword) {
        return (
            <Form.Group className="no-password-save">
                {label && <Form.Label className="label-style">{label}</Form.Label>}
                <div style={{ position: "relative" }}>
                    {/* This is a hidden dummy field to confuse password managers */}
                    <input
                        type="text"
                        name="username"
                        style={{ display: "none" }}
                        autoComplete="username"
                    />
                    <input
                        type="password"
                        name="password"
                        style={{ display: "none" }}
                        autoComplete="current-password"
                    />

                    {/* The actual input field styled to look like a password field */}
                    <Form.Control
                        name={`txt-${name}-${Math.random()}`} // Random name to prevent recognition
                        className="textInput"
                        required={required}
                        placeholder={placeholder}
                        value={value}
                        type="text" // Using text type, not password
                        disabled={disabled}
                        onClick={onClick}
                        onChange={handleInputChange}
                        maxLength={maxLength}
                        isInvalid={!!error}
                        onKeyDown={onKeyDown}
                        autoComplete="off"
                        style={{
                            WebkitTextSecurity: "disc", // For webkit browsers
                            MozTextSecurity: "disc" // For Mozilla browsers
                        }}
                    />
                </div>
                {error && <div className="error-message">{error}</div>}
            </Form.Group>
        );
    }

    return (
        <Form.Group autoComplete="off">
            {label && <Form.Label className="label-style">{label}</Form.Label>}
            {/* {type === "password" && (
                <input type="text" name="fakeUser" style={{ display: "none" }} autoComplete="off" />
            )} */}
            <Form.Control
                name={name}
                // name={type === "password" ? `password-${Math.random()}` : name}
                className="textInput"
                required={required}
                placeholder={placeholder}
                value={value}
                type={type}
                disabled={disabled}
                onClick={onClick}
                onChange={handleInputChange}
                maxLength={maxLength}
                isInvalid={!!error}
                autoComplete="off"
            // autoComplete={type === "password" ? "new-password" : "off"}
            />
            {error && <div className="error-message">{error}</div>}
        </Form.Group>
    );
};

export default TextInputField;
